<cc-dashboard-page-container>
  <ng-container title>
    {{ 'time-series-identifier.TIME_SERIES_ANALYSIS_IDENTIFIER' | transloco }}
  </ng-container>

  <cc-table-preview page-content>
    <cc-table-container [isLoading]="isLoading$ | async">
      <ng-container table-filter>
        <time-series-identifier-search
          [searchTermProperties]="['name', 'identifier']"
        ></time-series-identifier-search>
      </ng-container>

      <div table-buttons class="flex sm:flex-row">
        <cc-add-action-button
          [routerLink]="[navigateUrl, 'preview', 'new']"
        ></cc-add-action-button>


        <cc-action-button
          displayText="{{ 'time-series-identifier.parser.PLURAL' | transloco }}"
          [routerLink]="['/settings/time-series-identifier-parser']"
        ></cc-action-button>

      </div>

      <bo-mat-table
        matSort
        [data]="paging$ | async"
        (pageChange)="setPage($event)"
        (matSortChange)="onSort($event)"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'common.NAME' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'time-series-identifier.IDENTIFIER' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.identifier }}
          </td>
        </ng-container>

        <ng-container matColumnDef="areaMarketArea.name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'time-series-identifier.MARKET_AREA' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.areaMarketArea?.name }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="duration">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'time-series-identifier.DURATION' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
        </ng-container> -->

        <ng-container matColumnDef="isActive">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'common.IS_ACTIVE' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.isActive | yesNo }}
          </td>
        </ng-container>
      </bo-mat-table>
    </cc-table-container>
  </cc-table-preview>
</cc-dashboard-page-container>
